import React from 'react';

import scss from './Title.module.scss';

function Title({ title, subtitle }) {
  return (
    <div className={scss.wrapper}>
      {title ? <h3 className={scss.title}>{title}</h3> : null}
      {subtitle ? <span className={scss.subtitle}>{subtitle}</span> : null}
    </div>
  );
}

export default Title;
